import React, { useEffect, useState, useContext, useRef, use } from "react";
import Topbar from "../Recruiter/Topbar/Topbar";
import Textinput from "../elements/TextInput/TextInput";
import Button from "../elements/Button/Button";
import Card from "../elements/Card/Card";
import Aerolite from "../../assets/Images/Aerolite.png";
import ModalBox from "../elements/ModalBox/ModalBox";
import Selectbox from "../elements/SelectBox/SelectBox";
import Textarea from "../elements/TextArea/TextArea";
import Edit from "../../assets/Images/edit.jpg";
import { AuthContext } from "../../context/AuthContext";
import CryptoJS from "crypto-js";
import Notification from "../Notification/Notification";
import ClipLoader from "react-spinners/ClipLoader";
// import { set } from "mongoose";

const Companyoverview = () => {
  const { token } = useContext(AuthContext);

  // Helper function to check if a value is valid (not null, empty, or "null" string)
  const isValidValue = (value) => {
    return (
      value &&
      value.toString().toLowerCase() !== "null" &&
      value.toString().trim() !== ""
    );
  };
  const [isLoading, setIsLoading] = useState(false);
  const [companyName, setName] = useState("");
  const [companyProfile, setProfile] = useState("");
  const [companyProfilefullpath, setProfilefullpath] = useState("");
  const [companyOverview, setOverview] = useState("");
  const [companyWebsite, setWebsite] = useState("");
  const [companyIndustry, setIndustry] = useState("");
  const [companyIndustryVal, setIndustryval] = useState(0);
  const [companySize, setSize] = useState("");
  const [companySizeVal, setSizeval] = useState(0);
  const [companyHeadquarters, setHeadquarters] = useState("");
  const [companyFounded, setFounded] = useState("");
  const [companySpecialities, setCompanySpecialities] = useState([]);
  const [companyAddress, setAddress] = useState("");
  const [companyLocation, setLocation] = useState("");
  const [companyAbout, setAbout] = useState("");
  const [companyEmail, setEmail] = useState("");
  const formcompany = useRef(null);
  const formcompanysize = useRef(null);
  const formHeadquarter = useRef(null);
  const formIndustry = useRef(null);
  const formAddress = useRef(null);
  const formLocation = useRef(null);
  const formAbout = useRef(null);
  const formWebsite = useRef(null);
  const formFounded = useRef(null);
  const formSpecialties = useRef(null);
  const formEmail = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const [defaultSuggestions, setDefaultSuggestions] = useState([
    "Talent Acquisition",
    "Full Cycle Recruiting",
    "Recruitment Marketing",
    "Global Talent Acquisition",
    "Employee Retention Strategies",
    "Custom",
  ]);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null); // Track highlighted suggestion
  const [Specialitiesdefault, setSpecialitiesdefault] = useState([]);
  const fetchCompanyDetails = async () => {
    // setIsLoading(true);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/company/fetchCompanyDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await response.json();

      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      console.log("Company Details: ", decryptedData);
      if (!response.ok) {
        var errorMessage = "Something Went Wrong";
        if (data.error) errorMessage = data.error;
        showNotification(errorMessage, "error");
        throw new Error(data.error);
      } else {
        //   companyName.current.value=decryptedData[0]['name'];
        setName(decryptedData[0]["name"]);
        setProfile(decryptedData[0]["profile"]);
        setProfilefullpath(
          `${process.env.REACT_APP_SERVER_BASEURL}/companyprofile/${decryptedData[0]["profile"]}`
        );
        setOverview(decryptedData[0]["about"]);
        setWebsite(decryptedData[0]["url"]);
        setHeadquarters(decryptedData[0]["headquarters"]);
        setFounded(decryptedData[0]["founded_year"]);
        setSizeval(decryptedData[0]["size"]);
        setIndustryval(decryptedData[0]["industry"]);
        setLocation(decryptedData[0]["location"]);
        setAddress(decryptedData[0]["address"] || "");
        setAbout(decryptedData[0]["about"]);
        setEmail(decryptedData[0]["email"] || "");
        setCompanySpecialities(decryptedData[0]["specialities"] || []);
        console.log("name: ", companyName);
        if (decryptedData[0]["industry"]) {
          for (var i in Industry) {
            if (Industry[i]["id"] == decryptedData[0]["industry"]) {
              setIndustry(Industry[i]["label"]);
            }
          }
        }
        if (decryptedData[0]["size"]) {
          for (var i in Companysize) {
            if (Companysize[i]["id"] == decryptedData[0]["size"]) {
              setSize(Companysize[i]["label"]);
            }
          }
        }
      }
    } catch (error) {
      console.log("Error:", error);
      let errorMessage = "Something went wrong.";
      if (error.response && error.response.data && error.response.data.msg) {
        errorMessage = error.response.data.msg;
      } else if (error.message) {
        errorMessage = error.message;
      }
      //   showNotification(errorMessage, "error");
    } finally {
      //   setIsLoading(false); // Always hide loader after the request
    }
  };
  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const UploadImageTemp = async (file) => {
    setIsLoading(true);

    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/signUpImageTemp`, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      const result = await response.json();
      var result_path =
        result &&
        result["files"] &&
        result["files"]["file"] &&
        result["files"]["file"][0]
          ? result["files"]["file"][0]
          : "";
      var newpath =
        result_path && result_path["newFilename"]
          ? result_path["newFilename"]
          : companyProfile;
      setProfile(newpath);
      setProfilefullpath(
        `${process.env.REACT_APP_SERVER_BASEURL}/images/temp/${newpath}`
      );
      setIsLoading(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsLoading(false);
    }
  };

  const [notification, setNotification] = useState({ message: "", type: "" });
  const showNotification = (message, type) => {
    //For Notification
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const Sampleopen = () => setIsModalOpen(true);
  const closeForm = () => {
    setIsModalOpen(false);
    fetchCompanyDetails();
  };
  const profile_navbar_dropdown = () => {
    //Dropdown in navbar
    setIsOpen(!isOpen);
  };
  const [newSpecialty, setNewSpecialty] = useState("");
  const [showInput, setShowInput] = useState(false);

  const handleCustomSpecialty = () => {
    if (newSpecialty.trim()) {
      setCompanySpecialities([...companySpecialities, newSpecialty.trim()]);
      setNewSpecialty("");
      setShowInput(false);
    }
  };

  const handleSuggestionClick = (specialty) => {
    if (companySpecialities.includes(specialty)) {
      setCompanySpecialities(
        companySpecialities.filter((item) => item !== specialty)
      );
    } else {
      setCompanySpecialities([...companySpecialities, specialty]);
    }
  };

  const removeSpecialty = (specialty) => {
    setCompanySpecialities(
      companySpecialities.filter((item) => item !== specialty)
    );
  };

  const fetchSuggestions = async () => {
    const encryptedMetadata = localStorage.getItem("metadata");
    let company_id = "";
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      company_id = decryptedMetadata?.cid || "";
    }

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const jsonData = { cid: company_id, type: "Specialities" };
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(jsonData),
      process.env.REACT_APP_SECRETKEY
    ).toString();

    setIsLoading(true);
    try {
      const response = await fetch(`${serverURL}/masters/selectData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({ data: encryptedData }),
      });

      const data = await response.json();

      if (data.status !== "success") {
        showNotification(data.message || "Failed to fetch data.", "error");
        return;
      }

      let decryptedData = data.data;
      if (typeof data.data === "string") {
        try {
          decryptedData = JSON.parse(
            CryptoJS.AES.decrypt(
              data.data,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );
        } catch (decryptionError) {
          showNotification("Failed to decrypt data.", "error");
          return;
        }
      }
      const fetchedSuggestions = decryptedData.map((item) => item.spec_key);
      setSuggestions([...fetchedSuggestions, "Custom"]);
    } catch (error) {
      showNotification("Something went wrong while loading data.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSuggestions();
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) {
      UploadImageTemp(file);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      UploadImageTemp(file);
    }
  };
  const company_input = (e) => {
    // Allow only letters, spaces, dots, and hyphens for company names
    const input = e.target.value.replace(/[^a-zA-Z.\s-]/g, "");
    if (input.trim()) formcompany.current.classList.remove("border-red-600");
    setName(input);
  };

  const form_company_size = () => {
    const sizeValue = formcompanysize.current.value;
    if (sizeValue && sizeValue !== "0") {
      formcompanysize.current.classList.remove("border-red-600");
    }
    setSizeval(sizeValue);
  };

  const form_Headquarters = () => {
    formHeadquarter.current.classList.remove("border-red-600");
    setHeadquarters(formHeadquarter.current.value);
  };

  const form_Industry = () => {
    formIndustry.current.classList.remove("border-red-600");
    setIndustryval(formIndustry.current.value);
  };

  const form_Address = () => {
    const addressValue = formAddress.current.value.trim();
    if (addressValue && addressValue.length >= 10) {
      formAddress.current.classList.remove("border-red-600");
    }
    setAddress(formAddress.current.value);
  };

  const form_location = () => {
    formLocation.current.classList.remove("border-red-600");
    setLocation(formLocation.current.value);
  };

  const form_about = () => {
    formAbout.current.classList.remove("border-red-600");
    setAbout(formAbout.current.value);
  };

  const form_website = () => {
    const websiteValue = formWebsite.current.value.trim();
    if (websiteValue) formWebsite.current.classList.remove("border-red-600");
    setWebsite(formWebsite.current.value);
  };

  const form_Founded = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    if (input) formFounded.current.classList.remove("border-red-600");
    setFounded(input);
  };

  const form_email = () => {
    if (formEmail.current) {
      formEmail.current.classList.remove("border-red-600");
      setEmail(formEmail.current.value);
    }
  };
  const updateForm = async () => {
    var update_company = formcompany.current.value;
    var update_company_size = formcompanysize.current.value;
    var update_company_headquarter = formHeadquarter.current.value || "null";
    var update_company_industry = formIndustry.current.value || "null";
    var update_company_address =
      formAddress.current.value ||
      companyAddress ||
      "XYZ, Street 123, Bengaluru, 558946";
    console.log("Address field value:", formAddress.current.value);
    console.log("Address state value:", companyAddress);
    console.log("Final address value:", update_company_address);
    var update_company_location = formLocation.current.value || "null";
    var update_company_about = formAbout.current.value || "null";
    var update_company_website = formWebsite.current.value;
    var update_company_founded = formFounded.current.value || "0";
    var update_company_email =
      formEmail.current && formEmail.current.value
        ? formEmail.current.value.trim()
        : null;
    const update_specialties = JSON.stringify(companySpecialities);
    var update_company_profile = companyProfile;
    // Company Name: Required, string only (letters, spaces, dots, hyphens)
    if (!update_company || !update_company.trim()) {
      showNotification("Company Name is required", "error");
      formcompany.current.classList.add("border-red-600");
      return;
    }
    if (update_company.trim().length < 2) {
      showNotification("Company Name must be at least 2 characters", "error");
      formcompany.current.classList.add("border-red-600");
      return;
    }
    if (!/^[a-zA-Z.\s-]+$/.test(update_company.trim())) {
      showNotification(
        "Company Name can only contain letters, spaces, dots, and hyphens",
        "error"
      );
      formcompany.current.classList.add("border-red-600");
      return;
    }

    // Company Size: Required
    if (!update_company_size || update_company_size == 0) {
      showNotification("Company Size is required", "error");
      formcompanysize.current.classList.add("border-red-600");
      return;
    }

    // Address: Required
    if (!update_company_address || !update_company_address.trim()) {
      showNotification("Company Address is required", "error");
      formAddress.current.classList.add("border-red-600");
      return;
    }
    // if (update_company_address.trim().length < 10) {
    //   showNotification(
    //     "Please enter a complete address (minimum 10 characters)",
    //     "error"
    //   );
    //   formAddress.current.classList.add("border-red-600");
    //   return;
    // }

    // Website: Required and valid format
    if (!update_company_website || !update_company_website.trim()) {
      showNotification("Company Website is required", "error");
      formWebsite.current.classList.add("border-red-600");
      return;
    }
    // Basic URL validation
    const urlPattern =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    if (!urlPattern.test(update_company_website.trim())) {
      showNotification("Please enter a valid website URL", "error");
      formWebsite.current.classList.add("border-red-600");
      return;
    }

    // Email validation (optional but if provided should be valid)
    if (
      update_company_email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(update_company_email)
    ) {
      showNotification("Enter a valid email address", "error");
      if (formEmail.current) {
        formEmail.current.classList.add("border-red-600");
      }
      return;
    }

    // if (!update_company_founded) {
    //     showNotification("Enter Founded","error");
    //     formFounded.current.classList.add("border-red-600");
    //     return;
    // }
    // if (!update_specialties) {
    //     showNotification("Enter Specialties","error");
    //     formSpecialties.current.classList.add("border-red-600");
    //     return;
    // }
    // if (!update_company_profile) {
    //     showNotification("Upload Company Logo","error");
    //     return;
    // }

    const companyData = {
      name: update_company,
      size: update_company_size,
      head_quarters: update_company_headquarter,
      industry: update_company_industry,
      address: update_company_address,
      location: update_company_location,
      description: "nill",
      about: update_company_about,
      url: update_company_website,
      founded_year: update_company_founded,
      company_email: update_company_email,
      specialities: update_specialties,
      profile: update_company_profile,
    };
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedMetadata && decryptedMetadata.cid) {
        companyData.company_id = decryptedMetadata.cid;
      }
    }
    console.log("Sending company data :: ", companyData);
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(companyData),
      process.env.REACT_APP_SECRETKEY
    ).toString();
    const serverURL = process.env.REACT_APP_SERVER_URL;
    var encryptjson = { data: encryptedData };
    setIsLoading(true);
    try {
      const response = await fetch(`${serverURL}/company/updateCompany`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(encryptjson),
      });
      const data = await response.json();
      if (!response.ok) {
        var errorMessage = "Something Went Wrong";
        if (data.error) errorMessage = data.error;
        showNotification(errorMessage, "error");
        throw new Error(data.error);
      }
      var notificationStatus = "";
      var notificationContent = "";
      if (data.status) {
        notificationStatus = data.status;
      }
      if (data.message) {
        notificationContent = data.message;
      }
      if (data.error) {
        notificationContent = data.error;
      }
      showNotification(notificationContent, notificationStatus);
      if (response.ok) {
        console.log(response, "response");
        setIsModalOpen(false);
        await fetchCompanyDetails();
      } else {
        throw new Error(data.error || "Error");
      }
    } catch (error) {
      console.log("Error:", error);
      let errorMessage = "Something went wrong.";
      if (error.response && error.response.data && error.response.data.msg) {
        errorMessage = error.response.data.msg;
      } else if (error.message) {
        errorMessage = error.message;
      }
      showNotification(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const Companysize = [
    { id: "0", label: "Select Size" },
    { id: "1", label: "Small (1-10 employees)" },
    { id: "2", label: "Medium (11-50 employees)" },
  ];
  const Industry = [
    { id: "0", label: "Select Industry" },
    {
      id: "1",
      label: " Information Technology Consulting & Professional Services",
    },
    { id: "2", label: "Finance, Banking & FinTech" },
    { id: "3", label: "Accounting" },
    { id: "4", label: " Agriculture & Forestry" },
    { id: "5", label: "Mining & Extraction" },
    { id: "6", label: "Construction & Infrastructure" },
    { id: "7", label: "Manufacturing" },
    { id: "8", label: "Wholesale & Distribution" },
    { id: "9", label: "Retail & E-Commerce" },
    { id: "10", label: "Transportation & Logistics" },
    { id: "11", label: " Utilities & Energy" },
    { id: "12", label: "Telecommunications" },
    { id: "13", label: "Real Estate & Property" },
    { id: "14", label: " Marketing, Advertising & PR" },
    { id: "15", label: "Media & Entertainment" },
    { id: "16", label: "Hospitality & Travel" },
    { id: "17", label: " Healthcare & Pharmaceuticals" },
    { id: "18", label: "Education & Training" },
    { id: "19", label: "Nonprofit & Social Services" },
    { id: "20", label: " Government & Public Administration" },
    { id: "21", label: "Defense & Aerospace" },
    { id: "22", label: "Environmental & Sustainability" },
    { id: "23", label: "Automotive & Transportation Equipment" },
    { id: "24", label: "Chemical & Petrochemical" },
    { id: "25", label: "Other / Miscellaneous" },
  ];

  const filteredSuggestions =
    suggestions?.filter((item) => item !== "Custom") || [];
  const displayedSuggestions =
    filteredSuggestions.length > 0 ? suggestions : defaultSuggestions;
  const modalBodyOverview = (
    <div className="w-full px-4 sm:px-6 lg:px-8">
      {/* Upload Company Logo Section */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Upload Company Logo
        </label>
        <div
          className="flex items-center justify-center w-full"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <label
            htmlFor="dropzone-file"
            className="flex items-center w-full h-20 border-2 border-green-300 border-dashed rounded-lg cursor-pointer bg-blue-50 hover:bg-gray-100 transition-colors"
          >
            <img
              src={companyProfilefullpath ? companyProfilefullpath : Aerolite}
              className="w-12 h-12 border-2 ml-3 mt-2 mb-2 mr-3 rounded-xl"
              alt="Company profile"
            />
            <div className="flex flex-col items-center justify-center pt-2 pb-2">
              <p className="mt-3 ml-2 text-xs text-gray-500">
                <span className="font-semibold text-green-500 mr-1">
                  Edit or Click here
                </span>
                to upload new Logo
              </p>
            </div>
            <input
              id="dropzone-file"
              onChange={handleFileChange}
              type="file"
              accept="image/*"
              className="hidden"
            />
          </label>
        </div>
      </div>

      {/* Company Name */}
      <div className="mb-4">
        <Textinput
          label="Company Name"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          InputRef={formcompany}
          OnInput={company_input}
          span="*"
          value={companyName}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      {/* Company Size */}
      <div className="mb-4">
        <Selectbox
          span="*"
          label="Company Size"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          name="companySize"
          value={companySizeVal}
          list={Companysize}
          InputRef={formcompanysize}
          onChange={form_company_size}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
          required
        />
      </div>

      {/* Headquarter */}
      <div className="mb-4">
        <Textinput
          label="Headquarter"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_Headquarters}
          InputRef={formHeadquarter}
          value={companyHeadquarters}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      {/* Industry */}
      <div className="mb-4">
        <Selectbox
          label="Industry"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          name="industry"
          value={companyIndustryVal}
          list={Industry}
          InputRef={formIndustry}
          onChange={form_Industry}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
          required
        />
      </div>

      {/* Address */}
      <div className="mb-4">
        <Textarea
          label="Address"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_Address}
          InputRef={formAddress}
          span="*"
          value={companyAddress || "XYZ, Street 123, Bengaluru, 558946"}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm resize-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          rows={3}
        />
      </div>

      {/* Location URL and Current Location */}
      <div className="mb-4">
        <div className="flex flex-col sm:flex-row gap-4 items-end">
          <div className="flex-1">
            <Textinput
              label="Location URL"
              labelClass="block text-sm font-medium text-gray-700 mb-2"
              OnInput={form_location}
              InputRef={formLocation}
              value={companyLocation}
              className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-gray-500 bg-gray-50 px-2 py-1 rounded-full">
              Or
            </span>
            <Button className="bg-teal-50 text-green-700 font-normal text-xs px-3 py-2 rounded-lg hover:bg-teal-100 transition-colors">
              Current Location
            </Button>
          </div>
        </div>
      </div>

      {/* About */}
      <div className="mb-4">
        <Textarea
          label="About"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_about}
          InputRef={formAbout}
          value={companyAbout}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm resize-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
          rows={4}
        />
      </div>

      {/* Company Website */}
      <div className="mb-4">
        <Textinput
          label="Company Website Link"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_website}
          InputRef={formWebsite}
          value={companyWebsite}
          span="*"
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      {/* Company Email */}
      <div className="mb-4">
        <Textinput
          label="Company Email"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_email}
          InputRef={formEmail}
          value={companyEmail}
          type="email"
          placeholder="company@example.com"
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      {/* Founded */}
      <div className="mb-4">
        <Textinput
          label="Founded"
          labelClass="block text-sm font-medium text-gray-700 mb-2"
          OnInput={form_Founded}
          InputRef={formFounded}
          value={companyFounded}
          className="w-full border border-[#BFE0E2] p-3 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      {/* Specialities */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Specialities
        </label>
        <div className="border border-[#BFE0E2] w-full min-h-[40px] p-3 rounded-lg flex flex-wrap gap-2">
          {companySpecialities.length > 0 ? (
            companySpecialities.map((speciality, index) => (
              <span
                key={index}
                className="flex items-center px-3 py-1 rounded-lg text-xs text-gray-700 bg-teal-50 border border-gray-200"
              >
                {speciality}
                <Button
                  onClick={() => removeSpecialty(speciality)}
                  className="ml-2 text-gray-500 !bg-transparent border-none font-bold hover:text-red-500 p-0"
                >
                  ×
                </Button>
              </span>
            ))
          ) : (
            <span className="text-gray-500 text-sm">
              No Specialities available
            </span>
          )}
        </div>
      </div>

      {/* Suggestions */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Suggestions
        </label>
        <div className="border border-[#BFE0E2] w-full min-h-[40px] p-3 rounded-lg">
          <div className="flex flex-wrap gap-2">
            {displayedSuggestions.map((speciality, index) =>
              speciality === "Custom" ? (
                showInput ? (
                  <div key={index} className="flex items-center gap-2">
                    <input
                      type="text"
                      value={newSpecialty}
                      onChange={(e) => setNewSpecialty(e.target.value)}
                      className="border border-gray-300 px-3 py-1 rounded-lg text-xs focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="Add custom specialty"
                    />
                    <Button
                      onClick={() => handleCustomSpecialty(newSpecialty)}
                      className="px-3 py-1 text-xs bg-teal-100 text-teal-700 border border-teal-300 rounded-lg hover:bg-teal-200 transition-colors"
                    >
                      Save
                    </Button>
                  </div>
                ) : (
                  <Button
                    key={index}
                    onClick={() => setShowInput(true)}
                    className="px-3 py-1 border border-gray-300 bg-white rounded-lg text-xs text-gray-700 hover:border-teal-400 transition-colors"
                  >
                    {speciality}
                  </Button>
                )
              ) : (
                <Button
                  key={index}
                  onClick={() => handleSuggestionClick(speciality)}
                  className={`px-3 py-1 border rounded-lg text-xs cursor-pointer transition-colors ${
                    companySpecialities.includes(speciality)
                      ? "border-teal-300 bg-teal-100 text-teal-700"
                      : "border-gray-300 bg-white text-gray-700 hover:border-teal-300"
                  }`}
                >
                  {speciality}
                </Button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const ModalFooterOverview = (
    <>
      <div className="mb-4 mt-6 sm:mt-10 mx-2 sm:mx-4 lg:mx-6">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:justify-center">
          <Button
            className="border-1 border-green-800 bg-white text-sm text-green-700 w-full sm:w-32 py-2 px-4 sm:px-8 rounded outline-none order-2 sm:order-1"
            onClick={closeForm}
          >
            Cancel
          </Button>
          <Button
            className="border-1 border-green-800 bg-green-700 text-sm text-white w-full sm:w-32 py-2 px-4 sm:px-8 rounded outline-none order-1 sm:order-2"
            onClick={updateForm}
          >
            Save
          </Button>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: "", type: "" })}
      />
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="flex flex-col items-center">
            <ClipLoader color="#3498db" loading={isLoading} size={50} />
            <span className="text-white mt-4">Company Adding...</span>
          </div>
        </div>
      )}
      <Card
        CardClass="bg-white shadow rounded-lg overflow-hidden w-full mb-4 lg:mb-10 border-white shadow px-2 sm:px-4"
        CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2"
        body={
          <>
            <div className="flex flex-col sm:flex-row border-b-2 border-gray-100 pb-4">
              <div className="flex flex-col sm:flex-row justify-between w-full">
                <div className="flex items-start sm:items-center mb-3 sm:mb-0">
                  <img
                    src={
                      companyProfilefullpath ? companyProfilefullpath : Aerolite
                    }
                    className="w-12 h-12 sm:w-14 sm:h-14 border-2 mt-2 sm:mt-3 mr-3 mb-2 sm:mb-3 rounded-xl flex-shrink-0"
                    alt="Company Logo"
                  />
                  <div className="flex-1 min-w-0">
                    <h1 className="text-lg sm:text-xl mt-2 sm:mt-3 font-normal text-black dark:text-white truncate">
                      {isValidValue(companyName) ? companyName : "N/A"}
                    </h1>
                  </div>
                </div>
                <div className="flex justify-end sm:justify-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    onClick={Sampleopen}
                    className="ml-0 sm:ml-4 mt-2 sm:mt-8 cursor-pointer hover:scale-110 transition-transform"
                    viewBox="0 0 24 24"
                    fill="green"
                  >
                    <path
                      d="M13.0207 5.82839L15.8491 2.99996L20.7988 7.94971L17.9704 10.7781M13.0207 5.82839L3.41405 15.435C3.22652 15.6225 3.12116 15.8769 3.12116 16.1421V20.6776H7.65669C7.92191 20.6776 8.17626 20.5723 8.3638 20.3847L17.9704 10.7781M13.0207 5.82839L17.9704 10.7781"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {isModalOpen && (
                    <div>
                      <ModalBox
                        Modal_Body={modalBodyOverview}
                        Modal_Footer={ModalFooterOverview}
                        Modal_Close_Func={closeForm}
                        Modal_Header="Edit Company Profile"
                        modal_Header_Text="pl-4 m-0"
                        modal_Header_Class="border-gray-300 border-b-2 z-50 bg-white font-medium sticky top-0 py-3 flex items-center"
                        modal_Close_Class="border-2 border-gray-300 rounded-lg pl-2 pt-1 pb-1 pr-2"
                        cardClass="bg-white rounded-2xl shadow-lg overflow-y-scroll w-full sm:w-11/12 md:w-3/4 lg:w-2/4 xl:w-2/5 h-[95%] sm:h-[90%] p-0 max-w-2xl mx-4 sm:mx-0"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="px-2 sm:px-0">
              <div className="mt-4 sm:mt-6">
                <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                  Overview
                </h3>
                <p className="text-gray-500 text-sm sm:text-base leading-relaxed">
                  {isValidValue(companyOverview) ? companyOverview : "N/A"}
                </p>
              </div>

              <div className="mt-4 sm:mt-6">
                <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                  Website
                </h3>
                <p className="text-gray-500 text-sm sm:text-base">
                  {isValidValue(companyWebsite) ? (
                    <a
                      href={companyWebsite}
                      className="text-blue-600 hover:underline break-all"
                    >
                      {companyWebsite}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>

              <div className="mt-4 sm:mt-6">
                <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                  Email
                </h3>
                <p className="text-gray-500 text-sm sm:text-base">
                  {isValidValue(companyEmail) ? (
                    <a
                      href={`mailto:${companyEmail}`}
                      className="text-blue-600 hover:underline break-all"
                    >
                      {companyEmail}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6">
                <div>
                  <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                    Industry
                  </h3>
                  <p className="text-gray-500 text-sm sm:text-base">
                    {isValidValue(companyIndustry) ? companyIndustry : "N/A"}
                  </p>
                </div>

                <div>
                  <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                    Company Size
                  </h3>
                  <p className="text-gray-500 text-sm sm:text-base">
                    {isValidValue(companySize) ? companySize : "N/A"}
                  </p>
                </div>

                <div>
                  <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                    Headquarters
                  </h3>
                  <p className="text-gray-500 text-sm sm:text-base">
                    {isValidValue(companyHeadquarters)
                      ? companyHeadquarters
                      : "N/A"}
                  </p>
                </div>

                <div>
                  <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                    Founded
                  </h3>
                  <p className="text-gray-500 text-sm sm:text-base">
                    {isValidValue(companyFounded) && companyFounded !== "0"
                      ? companyFounded
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="mt-4 sm:mt-6">
                <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                  Specialities
                </h3>
                <p className="text-gray-500 text-sm sm:text-base">
                  {companySpecialities && companySpecialities.length > 0
                    ? companySpecialities
                        .filter((spec) => isValidValue(spec))
                        .join(", ") || "N/A"
                    : "N/A"}
                </p>
              </div>

              <div className="mt-4 sm:mt-6">
                <h3 className="text-black text-base sm:text-lg font-medium mb-2">
                  Address
                </h3>
                <p className="text-gray-500 text-sm sm:text-base">
                  {isValidValue(companyAddress) &&
                  companyAddress !== "XYZ, Street 123, Bengaluru, 558946"
                    ? companyAddress
                    : "N/A"}
                </p>
              </div>
            </div>
            {/* <div className="mt-4 sm:mt-6">
              <h3 className="text-black text-base sm:text-lg font-medium mb-2 px-2 sm:px-0">
                Location
              </h3>
              <div className="relative w-full h-48 sm:h-64 md:h-72 mx-2 sm:mx-0 rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.041465472381!2d144.9630932153119!3d-37.81410797975148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577f9cd6f620e33!2sFederation%20Square!5e0!3m2!1sen!2sau!4v1602117830944!5m2!1sen!2sau"
                  className="absolute inset-0 w-full h-full border-0"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Company Location"
                />
              </div>
            </div> */}
          </>
        }
      />
    </>
  );
};
export default Companyoverview;
